import React, {Component} from "react";
import {Route, Switch} from "react-router";
import ErrorRender from "./component/error/ErrorRender";
import GateDashboard from "./component/dashboard/GateDashboard";
import GatePosition from "./component/position/GatePosition";
import RegisterToPosition from "./component/register/RegisterToPosition";
import ProfileLandingPage from "./component/afterRegistration/ProfileLandingPage";
import GlobalRegister from "./component/globalRegister/GlobalRegister";
import AgencyComponent from "./component/agency/AgencyComponent";
import {CSSTransition, TransitionGroup} from "react-transition-group";
import notFoundImage from './resources/404.png';
import AgencyPositionList from "./component/agency/AgencyPositionList";

export default class App extends Component{
    render() {
        return (
            <Route render={(location) => (
                <div className={'flexHeight'} style={{ paddingTop: '60px' }}>
                    <TransitionGroup component={null}>
                        <CSSTransition timeout={{ enter: 300, exit: 300}} classNames={'fade flexHeight'} key={location.key} >
                            <Switch>
                                <Route exact path="/gate/" component={ErrorRender}/>
                                <Route exact path="/gate/error/:code" component={ErrorRender}/>
								<Route exact path="/gate/error/:code/:source" component={ErrorRender}/>

								<Route exact path="/gate/:customerName/positions" component={GateDashboard}/>
                                <Route exact path="/:lang/gate/:customerName/positions" component={GateDashboard}/>
                                <Route exact path="/gate/:customerName" component={GateDashboard}/>
                                <Route exact path="/:lang/gate/:customerName" component={GateDashboard}/>

                                <Route exact path="/gate/:customerName/position/:positionId" component={GatePosition}/>
                                <Route exact path="/:lang/gate/:customerName/position/:positionId" component={GatePosition}/>

                                <Route exact path="/gate/:customerName/positions/:source" component={GateDashboard}/>
                                <Route exact path="/:lang/gate/:customerName/positions/:source" component={GateDashboard}/>

                                <Route exact path="/gate/:customerName/position/:positionId/:source" component={GatePosition}/>
                                <Route exact path="/:lang/gate/:customerName/position/:positionId/:source" component={GatePosition}/>

								<Route exact path="/gate/:customerName/register/:positionId" component={RegisterToPosition}/>
								<Route exact path="/:lang/gate/:customerName/register/:positionId" component={RegisterToPosition}/>
								<Route exact path="/gate/:customerName/register/:positionId/:source" component={RegisterToPosition}/>
                                <Route exact path="/:lang/gate/:customerName/register/:positionId/:source" component={RegisterToPosition}/>

                                <Route exact path="/gate/:customerName/profile" component={ProfileLandingPage}/>
                                <Route exact path="/:lang/gate/:customerName/profile" component={ProfileLandingPage}/>

                                <Route exact path="/gate/:customerName/global-register/:source" component={GlobalRegister}/>
                                <Route exact path="/:lang/gate/:customerName/global-register/:source" component={GlobalRegister}/>
                                <Route exact path="/gate/:customerName/global-register" component={GlobalRegister}/>
                                <Route exact path="/:lang/gate/:customerName/global-register" component={GlobalRegister}/>

                                <Route exact path="/:lang/gate/:customerName/agency/:agencyHash?/add-candidate" component={AgencyPositionList}/>
                                <Route exact path="/gate/:customerName/agency/:agencyHash?/add-candidate" component={AgencyPositionList}/>

                                <Route exact path="/:lang/gate/:customerName/agency/:agencyHash?/add-candidate/:positionId" component={AgencyComponent}/>
                                <Route exact path="/gate/:customerName/agency/:agencyHash?/add-candidate/:positionId" component={AgencyComponent}/>
                                <Route>
                                    <div style={{ textAlign: 'center' }}>
                                        <img src={notFoundImage} className="img-fluid" alt="not found" />
                                    </div>
                                </Route>
                            </Switch>
                        </CSSTransition>
                    </TransitionGroup>
                </div>
            )}/>
        );
    }
}
